import config from 'config';

import { ProductType } from '~/techstyle-shared/react-products';

import { getAvailableProductQuantity } from './getAvailableProductQuantity';
import { isSoldOut } from './isSoldOut';

const locationLowStockIndicator = config.get(
  'public.quantityRules.locationLowStockIndicator'
);

export const isCriticalLowStock = ({ product, region }) => {
  if (
    !product ||
    product.productTypeId === ProductType.BUNDLE ||
    isSoldOut({ product })
  ) {
    return false;
  }

  const availableProductQuantity = getAvailableProductQuantity(product);
  const lowStockRules = locationLowStockIndicator.masterProduct[region];

  return availableProductQuantity <= lowStockRules.criticalStockMax;
};
